<template>
  <svg
    class="loading-animation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="0 0 100 100"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      :r="radius"
      stroke="currentColor"
      :stroke-dasharray="`${circleCutout} ${circleCutout * 2}`"
      stroke-linecap="round"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>

<script>
export default {
  props: {
    strokeWidth: {
      type: Number,
      default() {
        return 10
      },
    },
  },
  data() {
    return { radius: 50 - this.strokeWidth / 2 }
  },
  computed: {
    circleCutout() {
      return (2 * this.radius * Math.PI) / 3
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loading-animation {
  color: $mainColor;
  font-size: 1.25em;
  width: 1em;
  height: 1em;
  animation: spin 1.5s linear infinite;
}
</style>
